import { UserInDto } from '../../../types/user.dto'

export const NEW_USER = 'NEW_USER'
export const NEW_USER_ERROR = 'NEW_USER_ERROR'
export const NEW_USER_SUCCESS = 'NEW_USER_SUCCESS'
export const RESET_NEW_USER = 'RESET_NEW_USER'

export interface NewUser {
  type: typeof NEW_USER
  payload: UserInDto
}

export interface NewUserSuccess {
  type: typeof NEW_USER_SUCCESS
  payload: UserInDto
}

export interface NewUserError {
  type: typeof NEW_USER_ERROR
  payload: boolean | string
}

export interface ResetNewUser {
  type: typeof RESET_NEW_USER
  payload: null
}

export interface State {
  data: UserInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewUser | NewUserSuccess | NewUserError | ResetNewUser
